import { VACATION_DAYS_SETUP_CONFIG } from '../../../../config/pension-policy.config';

export const getStandardHolidayPay = (paidHoliday, defaultValue: number = 0) => {
  const found = VACATION_DAYS_SETUP_CONFIG.find((item) => item.holidayPerYear === paidHoliday);

  if (!found) {
    if (defaultValue) {
      return defaultValue;
    }

    return null;
  }

  return found.holidayPayMultiple;
};
